import { render, staticRenderFns } from "./DiagramBlock.vue?vue&type=template&id=2f656b51&"
import script from "./DiagramBlock.vue?vue&type=script&lang=js&"
export * from "./DiagramBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports